import {
  Bundle,
  BundleId,
  BundleLine,
  BundleLineId,
  BundleLineVariant,
  BundleLineVariantId,
} from "@greeter/core";
import { indexById } from "@greeter/map";

export function indexBundleLinesByVariantLines(bundles: Array<Bundle>) {
  const m = new Map<BundleLineVariantId, BundleLine>();
  for (const bundle of bundles) {
    for (const line of bundle.lines) {
      for (const variant of line.variants) {
        m.set(variant.id, line);
      }
    }
  }
  return m;
}

export function indexBundles(bundles: Array<Bundle>): Map<BundleId, Bundle> {
  return indexById(bundles);
}

export function indexBundleLines(
  bundles: Array<Bundle>
): Map<BundleLineId, BundleLine> {
  const m = new Map<BundleLineId, BundleLine>();
  for (const b of bundles) {
    for (const bl of b.lines) {
      m.set(bl.id, bl);
    }
  }
  return m;
}

export function indexBundleLineVariants(
  bundles: Array<Bundle>
): Map<BundleLineVariantId, BundleLineVariant> {
  const m = new Map<BundleLineVariantId, BundleLineVariant>();
  for (const b of bundles) {
    for (const bl of b.lines) {
      for (const blv of bl.variants) {
        m.set(blv.id, blv);
      }
    }
  }
  return m;
}
